import BaseApi from './base-api';
import { formatDateForApi } from './api-helpers';

class ChartApi extends BaseApi {
  getHistoryExchange(base = 'USD', against = 'IDR', start, end) {
    const defaultStart = formatDateForApi(new Date());
    let queries = '';
    queries += `base=${base}`;
    queries += `&symbols=${against}`;
    queries += `&start_at=${start ? formatDateForApi(start) : defaultStart}`;
    queries += `&end_at=${end ? formatDateForApi(end) : defaultStart}`;
    return this.get(`https://api.exchangeratesapi.io/history?${queries}`, null, false);
  }
}

export default ChartApi;
